// PaymentsPolicyPage.jsx
import React from "react";
import { LOOP_LEGAL_PAYMENTS_VERSION, LOOP_LEGAL_UPDATED_LABEL, LOOP_SUPPORT_EMAIL } from "../utils/legalVersions";

const SECTIONS = [
  {
    "title": "1. Alcance",
    "body": "Esta política complementa los Términos y condiciones y explica cómo se manejan pagos registrados, pagos online, cancelaciones, no-show, reembolsos, suscripciones de membresía, créditos, fidelidad y cargos de Loop a negocios.",
    "bullets": [],
    "callout": "Las suscripciones online solo generan beneficios después de que el proveedor de pago confirme una transacción aprobada."
  },
  {
    "title": "2. Pago registrado",
    "body": "En pago registrado, el negocio cobra fuera de Loop o presencialmente, por ejemplo en efectivo, Yappy, tarjeta, transferencia u otro método. Loop solo registra estado, método, monto, propina, saldo o notas para control operativo del negocio.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "3. Pago online",
    "body": "Cuando el negocio active pago online, Loop puede facilitar un checkout o link mediante un proveedor externo como Wompi. El proveedor procesa el pago y Loop recibe la información mínima necesaria para actualizar el estado, conciliación y beneficios asociados.",
    "bullets": [
      "Loop no debe almacenar números completos de tarjeta, códigos de seguridad ni credenciales bancarias sensibles.",
      "Un pago solo se considera aprobado después de la confirmación del proveedor y de las validaciones de monto, moneda e identidad de la operación.",
      "Una pantalla de confirmación o una solicitud enviada no sustituye la validación final del proveedor."
    ],
    "callout": ""
  },
  {
    "title": "4. Anticipos, saldos y pagos parciales",
    "body": "",
    "bullets": [
      "El negocio puede solicitar anticipo, pago completo, pago parcial o pago al llegar.",
      "Una reserva puede quedar pendiente, parcial, pagada, cubierta, reembolsada, fallida o cancelada.",
      "El saldo pendiente puede cobrarse directamente por el negocio o por un nuevo flujo online si está disponible."
    ],
    "callout": ""
  },
  {
    "title": "5. Propinas",
    "body": "Las propinas pueden registrarse separadas del pago del servicio y pueden tener un método distinto. El negocio es responsable de su política de distribución, retención, impuestos, comisiones de trabajadores y cumplimiento aplicable.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "6. Membresías asignadas, créditos y fidelidad",
    "body": "Cuando una reserva se cubre con una membresía asignada manualmente, crédito, sello, punto, cortesía o beneficio, Loop puede mostrarla como cubierta. El negocio define vigencia, consumo, reversos, condiciones, vencimientos y restricciones de esos beneficios.",
    "bullets": [],
    "callout": "Una membresía asignada manualmente es distinta de una suscripción online recurrente y puede no requerir un pago procesado por Loop."
  },
  {
    "title": "7. Suscripciones online y renovación automática",
    "body": "Una suscripción online es un contrato recurrente entre el cliente y el negocio, facilitado técnicamente por Loop y el proveedor de pago cuando ese servicio se encuentre habilitado.",
    "bullets": [
      "El cliente debe aceptar expresamente el precio, frecuencia de cobro, política de cancelación y condiciones vigentes antes de iniciar el pago.",
      "El primer ciclo y cada renovación requieren una confirmación válida del proveedor de pago.",
      "Los beneficios no se activan por crear un borrador, abrir el checkout o intentar un pago; se activan únicamente después de una aprobación verificada.",
      "El plan, precio, moneda, beneficios y versiones legales aceptadas pueden guardarse como una copia del momento de la compra para preservar el contrato original.",
      "Si el negocio modifica un plan, el cambio no debe alterar silenciosamente los ciclos ya pagados; los cambios futuros deben comunicarse cuando corresponda."
    ],
    "callout": "La fase inicial de Loop puede mostrar una preparación de suscripción sin ejecutar cobros. Ese estado no constituye una membresía activa."
  },
  {
    "title": "8. Cancelación de suscripciones",
    "body": "Una preparación sin pago puede cancelarse inmediatamente. Cuando una suscripción ya está activa y tiene un periodo pagado, la cancelación normalmente se programa para el final de ese periodo, salvo que la ley aplicable, el negocio o una solución comercial exijan otro tratamiento.",
    "bullets": [
      "Programar la cancelación detiene renovaciones futuras, pero no elimina automáticamente el periodo ya pagado.",
      "El cliente puede retirar una cancelación programada antes de que termine el periodo, cuando esa opción esté disponible.",
      "La fecha efectiva, los beneficios restantes y cualquier reembolso dependen del estado real del pago y de la política aplicable."
    ],
    "callout": ""
  },
  {
    "title": "9. Pagos fallidos, reintentos y suspensión",
    "body": "Cuando las renovaciones automáticas estén activas, un pago rechazado o fallido puede dejar la suscripción pendiente, atrasada o suspendida. Loop y el proveedor pueden intentar nuevamente el cobro según las reglas comunicadas al cliente.",
    "bullets": [
      "Durante un eventual periodo de gracia, los beneficios pueden mantenerse temporalmente o limitarse según la política del negocio.",
      "Si el pago no se regulariza, la suscripción puede suspenderse o vencer.",
      "Actualizar el método de pago no garantiza la aprobación de un cargo posterior."
    ],
    "callout": "Loop deberá comunicar los reintentos y periodos de gracia antes de habilitarlos en producción."
  },
  {
    "title": "10. Cancelaciones y no-show de reservas",
    "body": "Cada negocio define sus ventanas de cancelación, penalidades, reprogramaciones y excepciones para reservas. Si un cliente no asiste, el negocio puede aplicar su política de no-show, incluyendo pérdida de anticipo, uso de crédito o medidas permitidas por su política y ley aplicable.",
    "bullets": [],
    "callout": "Cancelar una reserva no cancela automáticamente una suscripción recurrente, y cancelar una suscripción no cancela automáticamente reservas existentes."
  },
  {
    "title": "11. Reembolsos",
    "body": "",
    "bullets": [
      "Los reembolsos dependen de la política del negocio, el proveedor de pago, el método usado y las obligaciones legales aplicables.",
      "Los cargos de procesador, contracargos, comisiones bancarias o impuestos podrían no ser reembolsables en algunos casos.",
      "Loop puede ayudar a revisar información técnica, pero el negocio decide la solución comercial salvo obligaciones legales aplicables.",
      "Cancelar una renovación futura no implica por sí sola un reembolso del periodo vigente."
    ],
    "callout": ""
  },
  {
    "title": "12. Contracargos y disputas",
    "body": "Si ocurre un contracargo, disputa o pago rechazado, Loop y/o el proveedor de pago pueden solicitar información adicional. El negocio es responsable por evidencias de prestación del servicio, políticas aceptadas, recibos, mensajes y documentación comercial.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "13. Cargos de Loop a negocios",
    "body": "Loop puede cobrar a negocios por suscripciones, comisiones por reserva, comisiones por pagos procesados, módulos premium, automatizaciones, WhatsApp, reportes, inventario, membresías, fidelidad u otros servicios contratados. La falta de pago puede limitar funciones, suspender módulos o pausar acceso premium.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "14. Impuestos y contabilidad",
    "body": "Cada negocio es responsable por impuestos, facturación, contabilidad, declaraciones, reportes internos, pagos a trabajadores y cumplimiento legal de sus ingresos. Los reportes de Loop son herramientas operativas y no sustituyen asesoría contable o fiscal.",
    "bullets": [],
    "callout": ""
  }
];

function plainText() {
  return ["Loop Reservas — Pagos y reembolsos.", `Versión: ${LOOP_LEGAL_PAYMENTS_VERSION}`, `Actualización: ${LOOP_LEGAL_UPDATED_LABEL}`, "", ...SECTIONS.flatMap((section) => [section.title, section.body || "", ...(section.bullets || []).map((item) => `- ${item}`), section.callout ? `Nota: ${section.callout}` : "", ""]), `Contacto: ${LOOP_SUPPORT_EMAIL}`].filter((line, idx, arr) => line !== "" || arr[idx - 1] !== "").join("\n");
}

function downloadTextFile(filename, text) {
  try { const blob = new Blob([text], { type: "text/plain;charset=utf-8" }); const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); } catch (_) {}
}

const legalPageStyles = `
  .loop-legal-page { min-height: calc(100vh - 88px); background: radial-gradient(circle at 8% 0%, rgba(0,103,95,.12), transparent 30%), radial-gradient(circle at 92% 12%, rgba(251,247,239,.95), transparent 34%), linear-gradient(180deg,#fbfdfc 0%,#fff 48%,#f8fbfa 100%); padding: clamp(26px,4.5vw,68px) 18px 70px; color:#0b1220; box-sizing:border-box; }
  .loop-legal-wrap { width:min(1080px,100%); margin:0 auto; }
  .loop-legal-card { background:rgba(255,255,255,.94); border:1px solid rgba(207,225,222,.95); border-radius:34px; box-shadow:0 30px 90px rgba(15,23,42,.08); padding:clamp(26px,4vw,56px); overflow:hidden; }
  .loop-legal-topline { display:flex; align-items:flex-start; justify-content:space-between; gap:18px; margin-bottom:28px; }
  .loop-legal-kicker { color:#00675f; font-size:12px; font-weight:950; letter-spacing:.17em; text-transform:uppercase; margin-bottom:12px; }
  .loop-legal-title { margin:0; color:#0b1220; font-size:clamp(40px,5vw,68px); line-height:.96; letter-spacing:-.075em; font-weight:950; }
  .loop-legal-subtitle { margin:18px 0 0; color:#64748b; font-size:16px; line-height:1.65; font-weight:700; max-width:790px; }
  .loop-legal-version { flex:0 0 auto; border:1px solid rgba(0,103,95,.14); background:#f0fdfa; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; white-space:nowrap; }
  .loop-legal-actions { display:flex; flex-wrap:wrap; gap:9px; margin:24px 0 6px; }
  .loop-legal-actions button, .loop-legal-actions a { border:1px solid rgba(0,103,95,.16); background:#fff; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; text-decoration:none; cursor:pointer; }
  .loop-legal-actions .primary, .loop-legal-actions button.primary { background:#00675f; color:#fff; }
  .loop-legal-summary { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin:26px 0 8px; }
  .loop-legal-pill-card { border:1px solid rgba(207,225,222,.95); border-radius:22px; background:rgba(248,252,251,.86); padding:17px; }
  .loop-legal-pill-card strong { display:block; color:#0f172a; font-size:14px; font-weight:950; margin-bottom:6px; }
  .loop-legal-pill-card span { display:block; color:#64748b; font-size:13px; line-height:1.45; font-weight:700; }
  .loop-legal-content { margin-top:30px; display:grid; gap:24px; }
  .loop-legal-section { padding-top:24px; border-top:1px solid rgba(226,232,240,.95); }
  .loop-legal-section h2 { margin:0 0 10px; color:#0f172a; font-size:22px; line-height:1.18; font-weight:950; letter-spacing:-.035em; }
  .loop-legal-section p, .loop-legal-section li { color:#475569; font-size:15px; line-height:1.72; font-weight:650; }
  .loop-legal-section p { margin:0; }
  .loop-legal-section ul { margin:10px 0 0; padding-left:22px; }
  .loop-legal-section li + li { margin-top:7px; }
  .loop-legal-callout { margin-top:16px; border:1px solid rgba(0,103,95,.18); background:rgba(240,253,250,.82); color:#00675f; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-warning { margin-top:16px; border:1px solid rgba(245,158,11,.24); background:rgba(255,251,235,.86); color:#92400e; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-contact { display:inline; color:#00675f; font-weight:950; text-decoration:none; }
  .loop-legal-contact:hover { text-decoration:underline; }
  .loop-legal-note { margin-top:30px; padding:17px 19px; border-radius:22px; background:#f0fdfa; border:1px solid rgba(0,103,95,.16); color:#00675f; font-size:14px; line-height:1.5; font-weight:850; }
  @media (max-width:860px){ .loop-legal-summary{grid-template-columns:1fr;} .loop-legal-topline{display:block;} .loop-legal-version{display:inline-flex;margin-top:18px;} }
  @media (max-width:640px){ .loop-legal-page{padding:20px 12px calc(var(--loop-mobile-nav-height,72px) + 24px);} .loop-legal-card{border-radius:26px;padding:24px 18px;} .loop-legal-title{font-size:39px;letter-spacing:-.06em;} }
  @media print { .loop-legal-page{background:#fff!important;padding:0!important;} .loop-legal-card{box-shadow:none!important;border:0!important;border-radius:0!important;} .loop-legal-actions{display:none!important;} }
`;

export default function PaymentsPolicyPage() {
  return (
    <>
      <style>{legalPageStyles}</style>
      <main className="loop-legal-page">
        <div className="loop-legal-wrap">
          <section className="loop-legal-card">
            <div className="loop-legal-topline">
              <div>
                <div className="loop-legal-kicker">Pagos</div>
                <h1 className="loop-legal-title">Pagos y reembolsos.</h1>
                <p className="loop-legal-subtitle">Condiciones para pagos registrados, pagos online, anticipos, propinas, cancelaciones, no-show, reembolsos, membresías, créditos, fidelidad y cargos de Loop a negocios.</p>
              </div>
              <div className="loop-legal-version">{LOOP_LEGAL_PAYMENTS_VERSION}</div>
            </div>

            <div className="loop-legal-actions">
              <button type="button" className="primary" onClick={() => window.print()}>Imprimir / PDF</button>
              <button type="button" onClick={() => downloadTextFile("loop-politica-pagos.txt", plainText())}>Descargar TXT</button>
              <a href="/terms">Términos</a>
              <a href="/privacy">Privacidad</a>
              <a href="/payments">Pagos</a>
              <a href={`mailto:${LOOP_SUPPORT_EMAIL}`}>Soporte</a>
            </div>

            <div className="loop-legal-summary">
              <div className="loop-legal-pill-card"><strong>Pago registrado</strong><span>El negocio cobra por fuera o presencialmente; Loop registra estado, método y monto.</span></div>
              <div className="loop-legal-pill-card"><strong>Pago online</strong><span>Checkout con validación del proveedor antes de activar reservas o beneficios.</span></div>
              <div className="loop-legal-pill-card"><strong>Suscripciones</strong><span>Consentimiento recurrente, cancelación al final del periodo y activación tras pago aprobado.</span></div>
            </div>

            <div className="loop-legal-warning">Esta política no sustituye las políticas propias de cada negocio ni asesoría legal, contable o fiscal. Cada negocio debe comunicar sus condiciones comerciales al cliente.</div>

            <div className="loop-legal-content">
              {SECTIONS.map((section) => (
                <div className="loop-legal-section" key={section.title}>
                  <h2>{section.title}</h2>
                  {section.body ? <p>{section.body}</p> : null}
                  {section.bullets && section.bullets.length ? <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul> : null}
                  {section.callout ? <div className="loop-legal-callout">{section.callout}</div> : null}
                </div>
              ))}
            </div>
            <div className="loop-legal-note">Última actualización: {LOOP_LEGAL_UPDATED_LABEL}. Contacto oficial: <a className="loop-legal-contact" href={`mailto:${LOOP_SUPPORT_EMAIL}`}>{LOOP_SUPPORT_EMAIL}</a>.</div>
          </section>
        </div>
      </main>
    </>
  );
}
